import { useEffect, useRef } from "react";
import { Send } from "lucide-react";

interface ReviewCommentInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  submitting: boolean;
}

const MAX_HEIGHT = 140;

export default function ReviewCommentInput({ value, onChange, onSubmit, submitting }: ReviewCommentInputProps) {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, MAX_HEIGHT)}px`;
  }, [value]);

  const onKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  const canSend = value.trim().length > 0 && !submitting;

  return (
    <div className="mt-review-comment-input">
      <textarea
        ref={textareaRef}
        className="mt-review-comment-input__textarea"
        placeholder="Add a comment…"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        rows={1}
        disabled={submitting}
      />
      <button
        type="button"
        className="mt-review-comment-input__send"
        disabled={!canSend}
        onClick={onSubmit}
        aria-label="Send comment"
      >
        <Send size={16} />
      </button>
    </div>
  );
}
